import { css } from "@emotion/react";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

export const fixedTab = (isCurrent: boolean) =>
    css(
        {
            marginTop: sizeToken(1),
        },
        !isCurrent && {
            visibility: "hidden",
            height: 0,
            overflow: "hidden",
            position: "absolute",
            top: 0,
            left: 0,
        }
    );
